//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated by the ProcessTemplatesAfterBuild executable.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
(function () {
    "use strict";

    angular.module("app").factory("sentMail", SentMailFactory);

    SentMailFactory.$inject = ["apiClientFactory"];
    function SentMailFactory(apiClientFactory) {

        const routePrefix = "api/Communication/Mails/";

        return {
            ForDossier: apiClientFactory.get(routePrefix + "ForDossier/"),
            ForRequest: apiClientFactory.get(routePrefix + "ForRequest/"),
            GetFailed: apiClientFactory.post(routePrefix + "Failed/"),
        };
    }
})();
